import * as mixpanelTracker from '../../../mixpanel/mixpanelTracking'
import {
  REFRESH_API_TOKEN,
  REGISTER_SUCCESSFUL,
  REPLACE_USER,
  SAVE_LAST_AUTHORIZED_ROUTE,
  SET_PRACTICE_PROVIDERS,
  SET_SELECTED_TIMEZONE,
} from '../common/constants/reduxConstants'
import { getPracticeProvidersData } from '../common/http/data/practices'
import { clearVideoSession } from '../lyraTherapy/data/videoSessionSlice'

export const saveLastAuthorizedRoute = (location: any) => {
  return (dispatch: any) => {
    dispatch({
      type: SAVE_LAST_AUTHORIZED_ROUTE,
      payload: `${location.pathname}${location.search}`,
    })
  }
}

export const registerSuccessful = () => {
  mixpanelTracker.track({ event: 'REGISTER' })
  return {
    type: REGISTER_SUCCESSFUL,
  }
}

export const refreshApiToken = (token: any) => {
  return {
    type: REFRESH_API_TOKEN,
    payload: token,
  }
}

export const setSelectedTimeZone = (timezone: string) => ({
  type: SET_SELECTED_TIMEZONE,
  payload: timezone,
})

export const supervisorSelectProvider = (user: any) => (dispatch: any) => {
  dispatch({ type: REPLACE_USER, user })
  dispatch(clearVideoSession())
}

export const fetchPracticeProviders = (practiceId: string) => async (dispatch: any) => {
  try {
    const response = await getPracticeProvidersData(practiceId)
    const providers = response.data.practice_providers || []

    dispatch({
      type: SET_PRACTICE_PROVIDERS,
      payload: providers,
    })
    return providers
  } catch (error) {
    console.error('Failed to fetch practice providers:', error)
    // Dispatch empty array on error so the bar still renders
    dispatch({
      type: SET_PRACTICE_PROVIDERS,
      payload: [],
    })
    // Return empty array instead of throwing to prevent uncaught exceptions
    return []
  }
}
